import { Injectable } from '@angular/core';
import { APP_ROUTES } from '@app/constants';
import { API_URLS } from '@app/constants/apiUrls';
import { ApiHelper } from '@app/helpers';

@Injectable({
  providedIn: 'root'
})
export class ConductService {

  constructor(private apiHelper: ApiHelper) { }

  list(surveyId?: string | null, clientId?: string | null, formPopulateNotNeeded?: boolean) {
    let query: any = {}
    if(surveyId) query.survey = surveyId;
    if(clientId) query.client = clientId;
    if(formPopulateNotNeeded) query.formPopulateNotNeeded = true

    return this.apiHelper.get(API_URLS.CONDUCT, query)
  }

  add(payload: any) {
    return this.apiHelper.post(API_URLS.CONDUCT, payload)
  }

  duplicate(conductId: string) {
    return this.apiHelper.post(`${API_URLS.CONDUCT}/${conductId}/duplicate`, {})
  }

  update(id: string, payload: any) {
    return this.apiHelper.put(`${API_URLS.CONDUCT}/${id}`, payload)
  }

  info(id: string) {
    return this.apiHelper.get(`${API_URLS.CONDUCT}/${id}`)
  }

  download(id: string, type: string) {
    return this.apiHelper.get(`${API_URLS.CONDUCT}/${id}/download`, {
      type
    }, undefined, {
      responseType: 'blob'
    })
  }

  lock(id: string, lock: boolean) {
    return this.apiHelper.put(`${API_URLS.CONDUCT}/${id}/lock`, {
      lock
    })
  }

  archive(id: string, archive: boolean) {
    return this.apiHelper.put(`${API_URLS.CONDUCT}/${id}/archive`, {
      archive
    })
  }

  sendEmail(id: string) {
    return this.apiHelper.post(`${API_URLS.CONDUCT}/${id}/email-to-client`, {})
  }
}
